import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResidenceDegreeService } from './residence-degree.service';
import { ResidenceDegree } from './residence-degree';

import { Router, ActivatedRoute } from '@angular/router';
import { ModalService, ToastService } from '../../blocks';
import { Subject } from 'rxjs/Subject';

import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'residence-degree-List',
    templateUrl: './residence-degree-list.component.html',
    styleUrls: ['./residence-degree-list.component.css']
})
export class ResidenceDegreeListComponent implements OnInit, OnDestroy {
    residenceDegree: ResidenceDegree[];

    constructor(
        private _residenceDegreeService: ResidenceDegreeService,
        public translate: TranslateService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _modalService: ModalService,
        private _toastService: ToastService) { }
    private ngUnsubscribe: Subject<void> = new Subject<void>();


    getResidenceDegrees(id) {
        this.residenceDegree = [];
        this._residenceDegreeService.getResidenceDegree(id)
           .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
            residenceDegree => { this.residenceDegree = residenceDegree.data; },
            error => console.log(error),
            () => {
                null
            });
    }
    onSearchClick(search) {
      if(search)
        this.getResidenceDegrees(search.code);
      else {
        this.getResidenceDegrees(0);

      }
    }
    ngOnInit() {
        this.getResidenceDegrees(0);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    delete(residenceDegree: ResidenceDegree) {
        this._modalService.activeDelMes(residenceDegree.degreeNameAr, residenceDegree.degreeNameEn).then(responseOK => {
            if (responseOK) {
                this._residenceDegreeService.deleteResidenceDegree(residenceDegree.serial)
                   .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(c => {
                        if (c["returnFlag"]) {
                            this.getResidenceDegrees(0);
                        }
                    });
            }
        });
    }


    onRowIconClick(actionCode: number, residenceDegree: ResidenceDegree) {
        if (actionCode == 402)
            this._router.navigate([residenceDegree.serial], { relativeTo: this._route });
        if (actionCode == 403)
            this.delete(residenceDegree);
    }
}
